import {SystemRole} from "../Types";
import {q, useQueryData} from "../state";

export function useIsAdmin() {
  const whoAmI = useQueryData(q.whoAmI());
  return whoAmI.roles.some(role => role.system_role === SystemRole.Admin);
}
